import * as userTokenRequests from "../../api/userTokenRequest";
import * as invoiceTokenRequest from "../../api/invoiceTokenRequest";
import { START_LOAD, FINISH_LOAD } from "../reducers/team";
import { getTeams } from "./teams";

import { push } from "./message";
import { EN } from "../../ui/constants";

const startLoading = () => {
  return { type: START_LOAD };
};
const finishLoading = (team) => {
  return { type: FINISH_LOAD, payload: team };
};

export const getTeamProfile = (id) => {
  return (dispatch) => {
    dispatch(finishLoading(null));
    dispatch(startLoading());
    userTokenRequests
      .getTeamById(id)
      .then((team) => {
        dispatch(finishLoading(team));
      })
      .catch((error) => {
        dispatch(finishLoading(null));
        dispatch(push(error.message));
      });
  };
};
export const updateTeamProfile = (id, car_info, team_info) => {
  return (dispatch) => {
    userTokenRequests
      .updateTeam(id, car_info, team_info)
      .then((team) => {
        dispatch(push(EN.message.update_team));
        dispatch(getTeamProfile(id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};
export const sendInvitationToTeam = (id, email) => {
  return (dispatch) => {
    userTokenRequests
      .sendInvitation(id, email)
      .then((team) => {
        dispatch(push(EN.message.send_invitation));
        dispatch(getTeamProfile(id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const deleteMember = (id, team_id) => {
  return (dispatch) => {
    userTokenRequests
      .deleteUserFromMember(id)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};
export const approveMember = (id, slot, team_id) => {
  return (dispatch) => {
    userTokenRequests
      .approveUserToSlot(id, slot)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};
export const deleteMemberFromSlot = (id, team_id) => {
  return (dispatch) => {
    userTokenRequests
      .deleteUserFromSlot(id)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const payForTeamSlot = (id, nonce, team_id) => {
  return (dispatch) => {
    userTokenRequests
      .payForSlot(id, nonce)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
        dispatch(push(EN.message.pay_for_slot));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const payForTeamSlots = (team_id, driver_count, crew_count, nonce) => {
  return (dispatch) => {
    userTokenRequests
      .payForSlots(team_id, driver_count, crew_count, nonce)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
        dispatch(push(EN.message.pay_for_slots));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const addLicenseForSlot = (id, license, team_id, date) => {
  return (dispatch) => {
    userTokenRequests
      .addLicenseForSlot(id, license, date)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};
export const assignPayment = (from_slot_id, to_slot_id, team_id) => {
  return (dispatch) => {
    userTokenRequests
      .assignPayment(from_slot_id, to_slot_id)
      .then((team) => {
        dispatch(getTeamProfile(team_id));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const leaveTeam = (id) => {
  return (dispatch) => {
    return userTokenRequests
      .deleteFromTeam(id)
      .then((team) => {
        dispatch(getTeams());
        dispatch(finishLoading(null));
      })
      .catch((error) => {
        dispatch(push(error.message));
      });
  };
};

export const getInvoice = (id, team_id) => {
  return (dispatch) => {
    return invoiceTokenRequest.getInvoice(id);
  };
};
